import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FinalDocumentChecklistPanel } from './FinalDocumentChecklistPanel';

export const FinalDocumentChecklistDialog = ({
  student,
  onClose,
}: {
  student: { id: number; name: string } | null;
  onClose: () => void;
}) => (
  <Dialog open={!!student} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>Final Documentation Checklist{student ? ` — ${student.name}` : ''}</DialogTitle>
    <DialogContent dividers>
      {student && <FinalDocumentChecklistPanel studentId={student.id} />}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);
